import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {Tooltip as RmwcTooltip} from '@rmwc/tooltip'
import '@rmwc/tooltip/styles'

// TODO stevo: tooltip is rendering outside of the global ThemeProvider element in the document; figure out how to render it within and then use this instead
const theme = ({theme}) => css`
  &&&.mdc-theme--on-${theme} .rmwc-tooltip-inner {
    color: var(--mdc-theme-on-${theme});
  }
  &&&.mdc-theme--${theme}-bg .rmwc-tooltip-inner {
    background-color: var(--mdc-theme-${theme});
  }
  &&&.mdc-theme--${theme}-bg.rmwc-tooltip-placement-top .rmwc-tooltip-arrow,
  &&&.mdc-theme--${theme}-bg.rmwc-tooltip-placement-topLeft .rmwc-tooltip-arrow,
  &&&.mdc-theme--${theme}-bg.rmwc-tooltip-placement-topRight .rmwc-tooltip-arrow {
    background-color: var(--mdc-theme-${theme});
  }
`

const StyledRmwcTooltip = styled(RmwcTooltip)`
  &&& {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 12px;
    opacity: 1;
  }
  &&& .rmwc-tooltip-inner {
    color: #ffffff;
    background-color: #424af9;
  }
  &&&.rmwc-tooltip-placement-top .rmwc-tooltip-arrow,
  &&&.rmwc-tooltip-placement-topLeft .rmwc-tooltip-arrow,
  &&&.rmwc-tooltip-placement-topRight .rmwc-tooltip-arrow {
    border-top-color: #424af9;
  }
`

const Tooltip = ({theme, children, ...otherProps}) => {
  function camelToKebabCase(str) {
    return str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)
  }

  return (
    <StyledRmwcTooltip
      // TODO stevo: figure out why RmwcTooltip component w/ theme prop doesn't add theme class names and then remove this
      className={theme && theme.length ? theme.reduce((result, t) => `${result} mdc-theme--${camelToKebabCase(t)}`, '') : undefined}
      {...otherProps}>
      {children}
    </StyledRmwcTooltip>
  )
}

Tooltip.propTypes = {
  theme: PropTypes.array,
  children: PropTypes.any
}

export {Tooltip}
